/**
 * A dummy class to trigger the compiler to copy the font files
 */
/**
 * @asset(iconfont/fontawesome5/*)
 */
qx.Class.define("iconfont.fontawesome5.Load", {});
